
import { usePopupDragAndDrop } from "../../../../Context/PopupDragAndDrop";
import { useRequestsApi } from "../../../../Context/RequestsApi";
import notify from "devextreme/ui/notify";
import { useMemo, useState } from "react";
import { useButtonConfigs } from "./useButtonConfigs";
import { useExitModal } from "./useExitModal";
import { usePasswordChange } from "./usePasswordChange";
import { useServerInfo } from "./useServerInfo";
import { useThemeManagement } from "./useThemeManagement";

export function useLogic(props) {
  const { requestsApi } = useRequestsApi();
  const { setPopupDragAndDrop } = usePopupDragAndDrop();

  const [pwdModal, setPwdModal] = useState({ isVisible: false });
  const [pwd, setPwd] = useState({ current: "", next: "", confirm: "" });
  const [pwdError, setPwdError] = useState("");
  const [pwdSubmitting, setPwdSubmitting] = useState(false);

  const themeManagement = useThemeManagement();
  const exitModal = useExitModal();

  const buttonConfigs = useButtonConfigs(
    setPopupDragAndDrop,
    themeManagement.setThemesModal,
    exitModal.setExit,
    themeManagement.selectedTheme,
    themeManagement.theme,
    themeManagement.setConfirmTheme,
    themeManagement.setMessageError
  );

  const mainMenuClick = () => {
    props.setStates({ ...props.states, opened: !props.states.opened });
  };

  const handleSubmitPassword = usePasswordChange(
    pwd,
    setPwd,
    setPwdModal,
    setPwdError,
    setPwdSubmitting,
    requestsApi,
    notify
  );

  const changePassword = () => setPwdModal({ isVisible: true })

  return {
    pwdModal,
    setPwdModal,
    pwd,
    setPwd,
    pwdError,
    setPwdError,
    handleSubmitPassword,
    pwdSubmitting,
    mainMenuClick,
    changePassword,
  };
}
